import React from "react";

import "./assets/css/btnStyle.css";

const Button = (props: any) => {
  return (
    <button
      style={props.style}
      onClick={props.onClick}
      className={props.className}
      disabled={props.disabled}
    >
      {props.title}
    </button>
  );
};

export default Button;
